import ads from '@/services/googles/ads'
import { snakeCaseKeys } from './utils'

const EXPANDED_TEXT_AD = 'EXPANDED_TEXT_AD'
const RESPONSIVE_SEARCH_AD = 'RESPONSIVE_SEARCH_AD'

export const copyKeywords = async (customerId, itemKeywords, targetAdGroups) => {
  // preparing data for create ad
  const dataKeywords = itemKeywords
    .map(item => (snakeCaseKeys(item.adGroupCriterion.keyword)))
    .filter(c => c)

  // creating data for insert keyword into ad group
  const creates = targetAdGroups
    .reduce((results, { adGroup }) => {
      const tmps = dataKeywords.map(keyword => ({
        ad_group: adGroup.resourceName,
        keyword: keyword
      }))
      return results.concat(tmps)
    }, [])

  return ads.addAdGroupKeyword(customerId, creates)
}

export const copyAds = async (customerId, itemAds, targetAdGroups) => {
  // preparing data for create ad
  const dataAds = itemAds
    .map(item => {
      const ad = snakeCaseKeys(item.adGroupAd.ad)
      switch (ad.type) {
        case EXPANDED_TEXT_AD:
          return {
            type: ad.type,
            final_urls: ad.final_urls[0],
            expanded_text_ad: ad.expanded_text_ad
          }
        case RESPONSIVE_SEARCH_AD:
          return {
            type: ad.type,
            final_urls: ad.final_urls[0],
            responsive_search_ad: ad.responsive_search_ad
          }
      }
    })
    .filter(c => c)

  // creating data for insert ad into ad group
  const creates = targetAdGroups
    .reduce((results, { adGroup }) => {
      const tmps = dataAds.map(ad => ({
        ad_group: adGroup.resourceName,
        ad: ad
      }))
      return results.concat(tmps)
    }, [])

  return ads.addAdGroupAd(customerId, creates)
}

export const copyAdGroups = async (customerId, itemAdGroups, targetCampaigns) => {
  // inline function for download ad and keyword item
  const $loadAdGroup = async ({ adGroup }) => {
    const name = adGroup.name
    const itemAds = await ads.getAdGroupAds(customerId, adGroup.id)
    const itemKeywords = await ads.getAdGroupKeywords(customerId, adGroup.id)
    return { name, itemAds, itemKeywords }
  }

  // inline function for create ad group, ad and keuword
  const $createAdGroup = async (itemCampaigns, source) => {
    const creates = itemCampaigns.map(({ campaign }) => ({
      name: source.name,
      campaign: campaign.resourceName
    }))

    const { results } = await ads.addAdGroup(customerId, creates)
    const targetAdGroups = results.map(r => ({ adGroup: r })) // creating fake itemAdGroup
    const resKeywords = await copyKeywords(customerId, source.itemKeywords, targetAdGroups)
    const resAds = await copyAds(customerId, source.itemAds, targetAdGroups)
    return [resKeywords, resAds]
  }

  // download and storing to resources
  const resources = await Promise.all(
    itemAdGroups.map(item => $loadAdGroup(item))
  )

  // starting to create
  const results = await Promise.all(
    resources.map(resource => $createAdGroup(targetCampaigns, resource))
  )

  return results
}
